module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACtSURBVHgBdVFbDcMwDHSk/a9jEAiBUAiFUCYrg5XBIKwMAqEQoiHoGHi25KjX1D3p5MRnx48QGZi5Ez6FmXeswpFaiDMKCwQNwh58aiMmoNA1VbeDpiWhhcWpvoA+kbVQsTkJBfRMfMZHmGyuVyve6IwgHOz88DaU4YHk6An0VR2TXd50AdFmixnr6gp7H7Qn6CYLOqK1Fp3g3hYR64CHl8ToHHdzfc3OIYSfHv4YFCimSzpH1AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/priceCard/avatar.png
// module id = hSls
// module chunks = 1